// extracted by mini-css-extract-plugin
module.exports = {"team":"Team_team__3HMt-","teamMembers":"Team_teamMembers__1SKIT"};